import {useQuery} from '@tanstack/react-query';

import {getBasketballLeagues} from '../api';

export const QUERY__BASKETBALL_LEAGUES = 'basketballLeagues';

export const useGetBasketballLeagues = () => {
  return useQuery({
    queryKey: [QUERY__BASKETBALL_LEAGUES],
    queryFn: getBasketballLeagues,
  });
};
